export const pageRoute = {
  login: "login",
  home: "home",
  jubili: "jubili",
  jubDashboard: "dashboard",
  jubCompany: "company",
  jubUserlist: "user",
  //jubQolist: "quotation",
  jubSetting: "setting",
  jubUploadImage: "uploadImage",
  jubUploadImageItem: "uploadImage/UploadImageItem/:id",
  jubWebhook: "webhook",
  jubSettingForm: "company/:id/SettingForm",
  intake: "intake",
  intakeFeature: "feature-control",
  intakeFeatureEdit: "feature-control",
  intakeOrgList: "organization-list",
  intakeEmployee: "employee",
  intakeLicenseList: "license-list",
  intakeLicenseHistory: "license-list/:orgId/history",
  rolemanager: "rolemanager",
  error: {
    default: "error",
    pagenotfound: "pagenotfound"
  },
  designsystem: {
    default: "designsystem",
    design: {
      default: "design",
      intro: "intro",
      logo: "logo",
      colour: "colour",
      layout: "layout",
      typography: "typography",
      iconography: "iconography"
    },
    component: {
      default: "component",
      avatar: "avatar",
      badge: "badge",
      banner: "banner",
      button: "button",
      card: "card",
      carousel: "carousel",
      dropdown: "dropdown",
      icon: "icon",
      input: "input",
      list: "list",
      loading: "loading",
      model: "model",
      tab: "tab",
      toast: "toast",
      tooltip: "tooltip"
    }
  }
};
